import ActionSheet, { ActionSheetRef as RnActionSheetRef } from 'react-native-actions-sheet';

import { addWithConfig, makeNBComponent } from '../../utils';

export type { SheetProps } from 'react-native-actions-sheet';
export {
  SheetManager,
  SheetProvider,
  registerSheet,
  useScrollHandlers,
} from 'react-native-actions-sheet';

export const RnActionSheet = makeNBComponent(ActionSheet, 'RnActionSheet');
export default addWithConfig(RnActionSheet);

export type ActionSheetRef = RnActionSheetRef;
